import React, { useState } from 'react';
import { Modal } from '@material-ui/core';
import Button from 'components/Button';
import TextField from 'components/TextField';
import { Container, WrapperInput, WrapperButtons } from './styles';

export default function ModalAprovacao({ open, onClose, onConfirm }) {
  const [acao, setAcao] = useState(''); // 'aprovar' ou 'reprovar'
  const [justificativa, setJustificativa] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');

  const handleConfirm = async () => {
    if (!acao) {
      setErro('Selecione uma opção (Aprovar ou Reprovar)');
      return;
    }

    setLoading(true);
    try {
      await onConfirm(acao, justificativa.trim() || null);
      handleClose();
    } catch (error) {
      setErro(error.message || 'Erro ao processar a ação');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setAcao('');
    setJustificativa('');
    setErro('');
    setLoading(false);
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Container>
        <h2 style={{ marginBottom: '20px' }}>Aprovar ou Reprovar Cotação</h2>

        <WrapperInput>
          <TextField
            select
            label="Ação"
            value={acao}
            onChange={(e) => {
              setAcao(e.target.value);
              setErro('');
            }}
            fullWidth
            color="secondary"
            InputLabelProps={{ shrink: true }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="">Selecione uma opção</option>
            <option value="aprovar">Aprovar Cotação</option>
            <option value="reprovar">Reprovar Cotação</option>
          </TextField>
        </WrapperInput>

        {acao === 'reprovar' && (
          <WrapperInput>
            <TextField
              label="Quer nos contar o motivo da Reprovação? (Opcional)"
              name="justificativa"
              value={justificativa}
              onChange={(e) => {
                setJustificativa(e.target.value);
                setErro('');
              }}
              multiline
              rows={4}
              fullWidth
              color="secondary"
              placeholder="Digite o motivo da reprovação (opcional)"
              InputLabelProps={{ shrink: true }}
              helperText={`${justificativa.length} caracteres`}
            />
          </WrapperInput>
        )}

        {erro && (
          <div style={{ color: '#f44336', marginBottom: '10px', fontSize: '14px' }}>
            {erro}
          </div>
        )}

        <WrapperButtons>
          <Button
            label="Cancelar"
            type="button"
            onClick={handleClose}
            disabled={loading}
            style={{ backgroundColor: '#999' }}
          />
          <Button
            label={loading ? 'Processando...' : 'Confirmar'}
            type="button"
            onClick={handleConfirm}
            disabled={loading}
          />
        </WrapperButtons>
      </Container>
    </Modal>
  );
}

